import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';

import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { CanActivate } from '@angular/router';

import * as Auth from '../actions/auth.actions';
import * as fromAuth from '../reducers';

@Injectable()
export class AnonymousGuard implements CanActivate {

  // Constructor
  constructor(private store: Store<fromAuth.State>) {}

  // Can Activate
  canActivate(): Observable<boolean> {

    return this.store.select(state => state.auth.login.token)
      .map(authed => {
        if (authed) {
          this.store.dispatch(new Auth.DashboardRedirect());
          return false;
        }
        return true;
      })
      .take(1);
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/services/anonymous-guard.service.ts